import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import pageBg from '../assets/hero-bg.jpg'; 

const HeaderContainer = styled.div`
  background-color: #ededed;
  height: 90px;
  position: relative;
  overflow: hidden;
  z-index: 10;
  
  @media (max-width: 479px) {
    display: none; 
  }
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1328px;
  height: 90px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  border-radius: 35px;

  }
  
  @media (max-width: 1328px) {
    width: 100%;
    left: 0;
    transform: none;
  }
`;

const NavContent = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 40px;
  z-index: 2;
`;

const NavLink = styled(Link)`
  color: white;
  font-size: 18px;
  text-decoration: none;
  font-family: 'Geologica', Arial, sans-serif;
  position: relative;
  white-space: nowrap;
  
  &:hover {
    opacity: 0.9;
  }
  
  ${({ active }) => active && `
    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 51px;
      height: 3px;
      background-color: #ff9605;
    }
  `}
`;

const PageHeader = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const getActiveStatus = (path) => {
    return currentPath === path ? 1 : 0;
  };

  return (
    <HeaderContainer>
      <BackgroundImage>
        <img src={pageBg} alt="background" />
      </BackgroundImage>
      <NavContent>
        <NavLink to="/podbor-tyra?reload=true" active={getActiveStatus('/podbor-tyra')}>
          Подбор тура
        </NavLink>
        <NavLink to="/goryashchie-tury?reload=true" active={getActiveStatus('/goryashchie-tury')}>
          Горящие туры
        </NavLink>
        <NavLink to="/minimalnye-tseny?reload=true" active={getActiveStatus('/minimalnye-tseny')}>
          Лечебные туры
        </NavLink>
        <NavLink to="/strany?reload=true" active={getActiveStatus('/strany')}>
          Страны
        </NavLink>
        <NavLink to="/china" active={getActiveStatus('/china')}>
          Наши туры в Китай
        </NavLink>
        <NavLink to="/cruises" active={getActiveStatus('/cruises')}>
          Круизы
        </NavLink>
        <NavLink to="/o-nas" active={getActiveStatus('/o-nas')}>
          О компании
        </NavLink>
        <NavLink to="/kontakty" active={getActiveStatus('/kontakty')}>
          Контакты
        </NavLink>
      </NavContent>
    </HeaderContainer>
  );
};

export default PageHeader;